import { getFrenchBar } from "../../../../../common/helpers/frenchSyllables";
import { getTiriTamTiBar } from "../../../../../common/helpers/kodaly";
import { getAussieBar } from "../../../../../common/helpers/kodalyAussie";
import { getTakadimiBar } from "../../../../../common/helpers/takadimi";
import { IBar, INote, ISignature } from "../../../../../common/types";
import { RhythmSyllableType } from "../../../../store/user/models";
import { IState } from "./interfaces";

export const addRhytName = (rhytNameTypes: IState["rhytNameTypes"], newNote: { l?: INote["l"], d?: boolean }, locale: string) => {
    let name: string;
    switch (newNote.l) {
        case 1:
            name = locale === "hu" ? "táááá" : "taaaa";
            break;
        case 2:
            switch (newNote.d) {
                case true:
                    name = locale === "hu" ? "tááá" : "taaa";
                    break;
                default:
                    name = locale === "hu" ? "táá" : "taa";
            }
            break;
        case 4:
            switch (newNote.d) {
                case true:
                    name = locale === "hu" ? "tám" : "tam";
                    break;
                default:
                    name = locale === "hu" ? "tá" : "ta";
            }
            break;
        case 8:
            switch (newNote.d) {
                case true:
                    name = "tim";
                    break;
                default:
                    name = "ti";
            }
            break;
        default:
            name = "ri";
    }
    rhytNameTypes[name] = true;
};

export const getFirstNoteRhythmName = (bars: IBar[], signature: ISignature, rhythmSyllableType: RhythmSyllableType, locale: string) => {
    switch (rhythmSyllableType) {
        case RhythmSyllableType.Kodaly:
        case RhythmSyllableType.KodalyRiRiTaiTi:
        case RhythmSyllableType.KodalyTeTe:
            const note = bars.filter(bar => !!bar && bar.notes.filter(note => !note.r).length > 0)[0].notes.filter(note => !note.r)[0];
            if (!note) return "";
            switch (note.l) {
                case 16:
                    return rhythmSyllableType === RhythmSyllableType.KodalyTeTe ? "te" : "ri";
                case 8:
                    return "ti";
                default:
                    return locale === "hu" ? "tá" : "ta";
            }
        case RhythmSyllableType.Aussie:
            const bar = bars.filter(bar => !!bar && bar.notes.filter(note => !note.r).length > 0)[0]
            const firstNote = bar.notes.findIndex(note => !note.r);
            const aussieBar = getAussieBar(bar);
            const rhytName = aussieBar[firstNote].slice(0, 2);
            return rhytName === "ta" && locale === "hu" ? "tá" : rhytName;
        case RhythmSyllableType.KodalyTiRi:
        case RhythmSyllableType.KodalyTiRiTaiTi: {
            const bar = bars.filter(bar => !!bar && bar.notes.filter(note => !note.r).length > 0)[0]
            const firstNote = bar.notes.findIndex(note => !note.r);
            const tiriBar = getTiriTamTiBar(bar, rhythmSyllableType === RhythmSyllableType.KodalyTiRiTaiTi, false);
            const rhytName = tiriBar[firstNote].slice(0, 2);
            return rhytName === "ta" && locale === "hu" ? "tá" : rhytName;
        }
        case RhythmSyllableType.French: {
            const bar = bars.filter(bar => !!bar && bar.notes.filter(note => !note.r).length > 0)[0]
            const firstNote = bar.notes.findIndex(note => !note.r);
            const frenechBar = getFrenchBar(bar.notes, signature);
            const rhytName = frenechBar[firstNote]
            return rhytName;
        }
        case RhythmSyllableType.Gordon:
        case RhythmSyllableType.Takadimi:
        case RhythmSyllableType.Takatiki: {
            const bar = bars.filter(bar => !!bar && bar.notes.filter(note => !note.r).length > 0)[0]
            const firstNote = bar.notes.findIndex(note => !note.r);
            const takaBar = getTakadimiBar(bar.notes, signature, rhythmSyllableType);
            const rhytName = takaBar[firstNote]
            return rhytName;
        }
        default:
            return undefined;
    }
}